import React, { Component } from 'react'
import { connect } from 'react-redux'

import { DetallesLineaDialogView } from '../components/DetallesLineaDialogView'

class DetallesLineaDialog extends Component {
  render () {
    const { linea } = this.props
    return (
      <DetallesLineaDialogView
        linea={linea}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    linea: state.cuadroDeMandoMovimientos.detallesMovimientosLinea
  }
}
export default connect(mapStateToProps)(DetallesLineaDialog)
